import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalDateRangePicker from "../../modal/modal-date-range";
import { setGlobalDDLDatePeriodDB } from "../../../store/reducer/globalDDL.reducer";

const DDLDatePeriod = ({ className, togglerClassName, ...attrs }) => {
  const dispatch = useDispatch();

  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const btnDropdownRef = useRef(null);
  const [isShowDropdownContent, setIsShowDropdownContent] = useState(false);
  const [status, setStatus] = useState(null);
  const [customDateSelected, setCustomDateSelected] = useState();

  const [isModalDatePickerOpen, setIsModalDatePickerOpen] = useState(false);

  const {
    globalDDLDatePeriodDB
  } = useSelector((state) => state.globalDDL);
  const togglerDropdownContent = useCallback(() => {
    setIsShowDropdownContent((state) => !state);
  }, []);

  const changeMonth = useCallback((month) => {
    if (month === "01") {
      return "Jan";
    }
    if (month === "02") {
      return "Feb";
    }
    if (month === "03") {
      return "Mar";
    }
    if (month === "04") {
      return "Apr";
    }
    if (month === "05") {
      return "May";
    }
    if (month === "06") {
      return "Jun";
    }
    if (month === "07") {
      return "Jul";
    }
    if (month === "08") {
      return "Aug";
    }
    if (month === "09") {
      return "Sep";
    }
    if (month === "10") {
      return "Oct";
    }
    if (month === "11") {
      return "Nov";
    }
    if (month === "12") {
      return "Dec";
    }
  }, []);

  const formatDateRange = useCallback(
    (date1, date2) => {
      const startDateSplittedByDash = date1.split("-");
      const endDateSplittedByDash = date2.split("-");

      const startDate = `${startDateSplittedByDash[2]} ${changeMonth(
        startDateSplittedByDash[1]
      )} ${startDateSplittedByDash[0]}`;
      const endDate = `${endDateSplittedByDash[2]} ${changeMonth(
        endDateSplittedByDash[1]
      )} ${endDateSplittedByDash[0]}`;

      return `${startDate} - ${endDate}`;
    },
    [changeMonth]
  );

  useEffect(() => {
    const handleClick = (evt) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current.contains(evt?.target) &&
        dropdownContentRef?.current?.classList.contains("active")
      ) {
        setIsShowDropdownContent(false);
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document?.removeEventListener("click", handleClick);
    };
  }, []);

  const onClickSelectedData = useCallback(
    (item) => {
      if (item?.value !== "Custom Period") {
        const period_date = {
          filter: item?.value,
        };
        dispatch(setGlobalDDLDatePeriodDB(period_date));
        setStatus(item);
        setIsShowDropdownContent(false);
        setCustomDateSelected();
        return;
      }
      setIsModalDatePickerOpen(true);
    },
    [dispatch]
  );

  const listDatePeriod = useMemo(() => {
    const list = [
      { value: "Today", label: "Today" },
      { value: "This Week", label: "This Week" },
      { value: "This Month", label: "This Month" },
      { value: "Last 3 Month", label: "Last 3 Months" },
      { value: "This Year", label: "This Years" },
      { value: "Custom Period", label: "Custom Period" },
    ];
    return list;
  }, []);

  const closeDatePicker = useCallback(() => {
    setIsModalDatePickerOpen(false);
  }, []);

  const getDateFromChild = useCallback(
    (startDate, endDate) => {
      const period_date = {
        filter: "Custom Date",
        from_date: startDate,
        thru_date: endDate,
      };
      setCustomDateSelected(formatDateRange(startDate, endDate));
      dispatch(setGlobalDDLDatePeriodDB(period_date));
      closeDatePicker();
    },
    [closeDatePicker, dispatch, formatDateRange]
  );

  return (
    <div
      className={"dropdown-dds".concat(className ? ` ${className}` : "")}
      ref={dropdownRef}
      {...attrs}
    >
      <button
        className={"value-mss"}
        onClick={togglerDropdownContent}
        ref={btnDropdownRef}
      >
        {customDateSelected !== undefined ? (
          <span className="font-roboto text-xl font-medium text-[#424242]">
            {customDateSelected}
          </span>
        ) : globalDDLDatePeriodDB?.filter ? (
          <span className="placeholder-mss">{globalDDLDatePeriodDB?.filter}</span>
        ):
        !status || status === null ? (
          <span className="placeholder-mss">Select Date Period</span>
        ) : (
          <span className="font-roboto text-xl font-medium text-[#424242]">
            {status?.label}
          </span>
        )}
      </button>
      <div></div>
      <div
        className={"dropdown-dds-menu".concat(
          isShowDropdownContent ? " active mt-2 pb-10" : ""
        )}
        ref={dropdownContentRef}
      >
        <div className="overflow-auto max-h-[250px]">
          {listDatePeriod.map((el, idx) => {
            return (
              <div
                key={idx}
                className={"dropdown-dds-item truncate"}
                onClick={() => onClickSelectedData(el)}
              >
                <div className="w-full flex justify-between px-2">
                  <span>{el?.label}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <ModalDateRangePicker
        isModalDatePickerOpen={isModalDatePickerOpen}
        handleOk={closeDatePicker}
        handleCancel={closeDatePicker}
        sendToParents={getDateFromChild}
      />
    </div>
  );
};

export default DDLDatePeriod;
